import React from 'react';
import { Link } from 'react-router-dom';
import BrandMark from './ui/BrandMark';

const Footer: React.FC = () => {
  return (
    <footer className="border-t border-border px-4 py-7 sm:px-6 lg:px-10">
      <div className="mx-auto flex max-w-[1160px] flex-wrap items-center justify-between gap-3 text-[13px] text-muted-foreground">
        <span className="flex items-center gap-2.5 font-display font-semibold text-foreground">
          <BrandMark size={22} className="rounded-[6px]" />
          Custody Planner
        </span>
        <div className="flex flex-wrap gap-6">
          <Link to="/app" className="transition-colors hover:text-foreground">Try now</Link>
          <Link to="/pricing" className="transition-colors hover:text-foreground">Pricing</Link>
          <Link to="/contact" className="transition-colors hover:text-foreground">Contact</Link>
          <Link to="/terms" className="transition-colors hover:text-foreground">Terms</Link>
          <Link to="/privacy" className="transition-colors hover:text-foreground">Privacy</Link>
        </div>
        <span>© {new Date().getFullYear()} ShiftFoundry Inc. · Not legal advice</span>
      </div>
    </footer>
  );
};

export default Footer;
